import { Injectable } from '@angular/core';
import { OauthAdapter } from './oauth.adapter';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAdapter extends OauthAdapter {
  protected provider = 'microsoft';

  constructor() {
    super();
  }
}

